import React, { useEffect } from 'react';
import { urlServer } from "../../util/api/v1";

const DocumentPage: React.FC = () => {
    useEffect(() => {
        document.body.style.overflow = "hidden";
    }, []);

    return <iframe title="Documents" style={{ all: 'inherit', height: '100vh', width: '100vw' }} src={urlServer} />;
};

export default DocumentPage;
